import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-serie',
  templateUrl: './text-serie.component.html',
  styleUrls: ['./text-serie.component.scss'],
  viewProviders: [ParentFormGroup],
})
export class TextSerieComponent implements OnInit {

  constructor() {}

  ngOnInit() {}  

}
